// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1k0QH","image":"styles_image__TBvgJ","item":"styles_item__oZDvL","link":"styles_link__w_mGI"};